import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Accordion, List, Typography, Divider } from "../ecosystem/";


const InHomeFaq = (props) => {
    const [openFaqIndex, setOpenFaqIndex] = useState();

    const faqs = [
        {
            question: "What is the In-Home Vaccines program?",
            answer: "The In-Home Vaccines program allows eligible patients’ and their families to schedule and receive vaccinations in the comfort and convenience of your home. Once the appointment is set, a trusted medical professional will visit your home, administer the vaccine(s) and document the encounter in your medical records, eliminating the need to commute to a healthcare facility."
        },
        {
            question: "Who’s eligible?",
            answer: <div><div className="faq-list-intro">To be eligible for an In-Home Vaccine you must be:</div><List typographyType="body-02" list={["3 and older.", "Adults must have a MyBSWHealth Account (can schedule for minor dependents).", "Haven't had an adverse reaction to a vaccine previously."]} /></div>
        },
        {
            question: "What vaccines are currently available?",
            answer: <List typographyType="body-02" list={["Influenza and Influenza High Dose", "COVID-19", "Tdap", "Shingles", "Pneumococcal"]} />
        },
        {
            question: "What are the hours of operation?",
            answer: "In-home vaccine appointments are available Monday-Friday from 8:00am-7:00pm and Saturday from 8:00am-1:00pm. Availability varies, so self-scheduling is available in MyBSWHealth."
        },
        {
            question: "Where is this service available?",
            answer: "Patients are able to select their location during booking, and appointments are available in all of North Texas."
        },
        {
            question: "How much does an in-home vaccine appointment cost? Will my insurance cover it?",
            answer: "In-home vaccine appointments will be billed to your insurance provider and any standard office visit copays will apply."
        },
        {
            question: "Can I schedule in-home vaccines for the entire family?",
            answer: "Yes, you can schedule in-home vaccines for you and your dependents. Dependents can be linked in your MyBSWHealth account."
        },
        {
            question: "Can I schedule a same day appointment and how long will the appointment take?",
            answer: "Currently, appointments can be scheduled as soon as five days in advance to allow for scheduling logistics and required pre-registration activities. Appointments are quick and the certified medical assistant will remain for observation after administering the dose(s)."
        },
        {
            question: "How are multi-dose vaccines scheduled?",
            answer: "You will schedule a new appointment for each dose. Once you are eligible for your next dose (for multi series vaccines) please schedule your next appointment."
        },
        {
            question: "Is BSWH delivering this service or is it provided by a 3rd party company?",
            answer: "BSWH has partnered with a trusted 3rd party vendor, Axle Health, for optimized scheduling and staffing services. The certified medical assistant, while employed by Axle Health, has been trained in all necessary BSWH policies and procedures, and documents the vaccinations in your MyBSWHealth medical record."
        },
        {
            question: "Where can I learn more about COVID-19 vaccinations?",
            answer: <span>You can learn more about COVID-19 vaccination options by visiting our  <Link to='/vaccineeligibility'>COVID-19 Frequently Asked Questions.</Link></span>
        }
    ];

    const getAccordionItems = () => {
        let items = [];

        faqs.map((q, index) => {
            items.push({
                heading: q.question,
                content: <div className="inhome-faq-answer">
                    {q.answer}
                </div>
            });
        });

        return items;
    }

    const onFaqClick = (e, index) => {
        if (openFaqIndex !== index) {
            setOpenFaqIndex(index);
        } else {
            setOpenFaqIndex(''); //Toggles accordion close
        }
    };

    return (<div className="row inhome-faq-wrapper">
        <div className="col-12 maxWidth-content">
            <div className="row">
                <div className="col-12 faq-box">
                    <Divider mTop="large" mBottom="xxlarge"/>
                    <Typography
                        type="heading-03"
                        tag="h2"
                    >
                        Frequently Asked Questions
                    </Typography>
                    <div className="collapse-wrapper">
                        <Accordion
                            openIndex={openFaqIndex}
                            toggle={(e, itemIndex) => onFaqClick(e, itemIndex)}
                            accordionItems={getAccordionItems()}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default InHomeFaq